import { render, staticRenderFns } from "./infodisc.vue?vue&type=template&id=088f340c&scoped=true"
import script from "./infodisc.vue?vue&type=script&lang=js"
export * from "./infodisc.vue?vue&type=script&lang=js"
import style0 from "./infodisc.vue?vue&type=style&index=0&id=088f340c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088f340c",
  null
  
)

export default component.exports